import React, { createContext, useState, useContext, useEffect } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const [userData, setUserData] = useState(null);

    const isLocalhost = window.location.hostname === 'localhost';

    //=======================================
    // FUNCION PARA INICIAR SESION
    //=======================================

    /*
    const logIn = (  ) => {
        const expires = new Date();
        expires.setDate( expires.getDate() + 1 );
        //console.log(data)
        //Cookies.set('ebt_token', 'R9345FG35D68BE6R56ER51BSD36R51E6TJ8J', { expires });
        // Cookies.set('ebt_id_user', data.user, { expires });
        // Cookies.set('ebt_nombre', data.nombre, { expires });
        // Cookies.set('ebt_menu', data.menu, { expires });
        // Cookies.set('ebt_perfil', data.perfil, { expires });

        setIsLoggedIn(true)

    };
    */
    const logIn = (token) => {
        /*
        const expires = new Date();
        expires.setDate(expires.getDate() + 1);
        Cookies.remove('ebt_token'); 
        Cookies.set('ebt_token', token, { expires }); 
        */

        sessionStorage.setItem('ebt_token', token); 

        const decoded = jwtDecode(token);
        setUserData(decoded);

        setIsLoggedIn(true);
    };

    //=======================================
    // FUNCION PARA CERRAR SESION
    //=======================================

    const logOut = () => {
        //Cookies.remove('ebt_token');
        sessionStorage.removeItem('ebt_token');
        setUserData(null);
        setIsLoggedIn(false);

        if (!isLocalhost) 
        {
            window.location.replace('https://ebtapps.com/');
        }
        
    };
    /*
    const logOut = () => {

        Cookies.remove('ebt_token');
        Cookies.remove('ebt_id_user');
        Cookies.remove('ebt_nombre');
        Cookies.remove('ebt_menu');

        setIsLoggedIn(false);

    };
    */

    //=======================================
    // USE EFFECT PARA VALIDAR TOKEN
    //=======================================

    /*
    useEffect(() => {
        

        const token = Cookies.get('ebt_token');

        if(!token){

            logOut()

        } else {

            setIsLoggedIn(true)

        }

    }, []);*/

    useEffect(() => 
    {
        //const token = Cookies.get('ebt_token');
        const token = sessionStorage.getItem('ebt_token');

/*         if (token) {
            setIsLoggedIn(true);
            return;
        } */
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserData(decoded);
                setIsLoggedIn(true);
            } catch (e) {
                logOut();
            }
            return;
        }

        // Buscar "key" en la URL
        const searchParams = new URLSearchParams(location.search);
        const key = searchParams.get('key');

        if (key) {
            const validarKey = async () => {
                try {
                    const payload = { key };
                    const { data } = await axios.post(`https://apiunidqr.ebtapps.com/api/login`, payload);

                    //if (data.success) {
                    if (data.success && data.token) {
                        logIn(data.token);

                        // Limpiar la URL (quitar ?key=...)
                        const cleanUrl = window.location.origin + window.location.pathname;
                        window.location.replace(cleanUrl);
                    } else {
                        //window.location.href = 'https://ebtapps.com/';
                        if (!isLocalhost) window.location.href = 'https://ebtapps.com/';
                    }
                } catch (error) {
                    console.error('Error al validar el key', error);
                    //window.location.href = 'https://ebtapps.com/';
                    if (!isLocalhost) window.location.href = 'https://ebtapps.com/';
                }
            };

            validarKey();
        } else {
            //window.location.href = 'https://ebtapps.com/';
            if (!isLocalhost) window.location.href = 'https://ebtapps.com/';
        }
    }, []);

    // =============================================

    return (

        // <AuthContext.Provider value={{ isLoggedIn, logIn, logOut}}>
        <AuthContext.Provider value={{ isLoggedIn, logIn, logOut, userData }}>
            { children }
        </AuthContext.Provider>

    )

}

export const useAuth = () => useContext(AuthContext);

export default AuthProvider